export enum CLIENT_TYPE {
  H5 = 7,
  web = 1
}
export const clientTypeBase = [
  {
    label: 'web网页',
    value: CLIENT_TYPE.web
  },
  {
    label: 'PC端客户端',
    value: 2
  },
  {
    label: 'IOS端APP',
    value: 3
  },
  {
    label: '安卓APP',
    value: 4
  },
  {
    label: '微信小程序',
    value: 5
  },
  {
    label: '钉钉小程序',
    value: 6
  },
  {
    label: 'H5网页',
    value: CLIENT_TYPE.H5
  }
]
export const clientTypeOptions = [
  ...clientTypeBase,
  {
    label: '无终端',
    value: 9
  }
]
// 1教师，2学生，3家长
export const serviceUserOptions = [
  {
    label: '教师',
    value: 1
  },
  {
    label: '学生',
    value: 2
  },
  {
    label: '家长',
    value: 3
  }
]
export const serviceOrgOptions = [
  {
    label: '学校',
    value: 1
  },
  {
    label: '单位',
    value: 2
  },
  {
    label: '培训机构',
    value: 3
  }
]
export const categoryOptions = [
  {
    label: '智慧教学',
    value: 1
  },
  {
    label: '智慧学习',
    value: 2
  },
  {
    label: '智慧研修',
    value: 3
  },
  {
    label: '智慧测评',
    value: 4
  },
  {
    label: '服务·管理',
    value: 5
  },
  {
    label: '成长·发展',
    value: 6
  },
  {
    label: '数据·统计',
    value: 7
  }
]
export const clientType = [
  {
    value: 0,
    label: '全部'
  },
  ...clientTypeBase
]
export const userType = [
  {
    value: 0,
    label: '全部'
  },
  ...serviceUserOptions
]
export const categoryList = [
  {
    value: 0,
    label: '全部'
  },
  ...categoryOptions
]
